export default "__VITE_ASSET__BtjDcDos__"